import {Layers} from "./Layers";
import * as types from "../shop/constants/ActionTypes";
import {isLoading} from "../shop/actions";
import { nanoid } from 'nanoid';

const intl = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

export function currency(str) {
    return intl.format(str);
}

export function calculateSum(cake, config) {
    return Object.keys(cake).reduce((s, group) => {
        const tag = cake[group];
        if (tag && config.items[tag]) {
            return s + parseFloat(config.items[tag].price);
        }
        return s;
    }, 0);
}

function needsCustomizer(cake, config) {
    if (cake.decor && config.items.hasOwnProperty(cake.decor)) {
        return config.items[cake.decor].customizer && config.items[cake.decor].customizer !== 'none';
    }
    return false;
}

export function cakeIsComplete(cake, config) {

    const hasAllGroups = Layers.reduce((r, group) => {
        return cake[group] && r;
    }, true);

    const custom = needsCustomizer(cake, config);

    if (custom) {
        if (!cake.customizer || !cake.customizer.type) {
            return false;
        }

        let customizationIsValid = false;
        switch (cake.customizer.type) {
            case 'text':
                customizationIsValid = cake.customizer.text && typeof cake.customizer.text === 'string' && cake.customizer.text.length > 0  && cake.customizer.text.length <= 30;
                break;
            case 'image':
                customizationIsValid = !!cake.customizer.image;
                break;
        }
        return hasAllGroups && customizationIsValid;
    }

    return hasAllGroups;
}

export function addCake(cake, config) {

    const cakeData = Object.assign({}, cake);

    if (cake.customizer) {
        switch (cake.customizer.type) {
            case 'text':
                cakeData.customizer = cake.customizer.text;
                break;
            case 'image':
                cakeData.fileId = nanoid();
                try {
                    window.sessionStorage.setItem(cakeData.fileId, cake.customizer.image);
                }
                catch (e) {

                }
                cakeData.customizer = 'Bild-Upload';
                break;
            default:
                delete cake.customizer;
        }
    }

    return jQuery.post(document.location.href, {
        'add-to-cart': config.id,
        'cake': cakeData
    });
}


// WEBPACK FOOTER //
// ./js/cake/Helper.js